import { Components, Theme } from '@mui/material/styles';

export const muiTooltipOverride: Components<Omit<Theme, 'components'>>['MuiTooltip'] = {
  defaultProps: {
    leaveDelay: 100
  }
};
